import React, { useEffect, useState } from "react";

export default function Avatar({ children, image }) {
  const [texto, setTexto] = useState("");

  useEffect(() => {
    const colors = [
      "#00AA55",
      "#009FD4",
      "#B381B3",
      "#939393",
      "#E3BC00",
      "#D47500",
      "#DC2A2A",
    ];

    function setColors() {
      const avatars = document.querySelectorAll(".avatar");

      avatars.forEach((avatar) => {
        const text = children; // => "AA"
        const name = !text
          ? text
          : text
              .match(/(^\S\S?|\b\S)?/g)
              .join("")
              .match(/(^\S|\S$)?/g)
              .join("")
              .toUpperCase();

        setTexto(name);

        const number = text ? numberFromText(text) : 0;
        avatar.style.backgroundColor = colors[number % colors.length]; // => "#DC2A2A"
      });
    }
    setColors();
  }, [children]);

  function numberFromText(text) {
    // numberFromText("AA");
    const charCodes = text
      .split("") // => ["A", "A"]
      .map((char) => char.charCodeAt(0)) // => [65, 65]
      .join(""); // => "6565"
    return parseInt(charCodes, 10);
  }

  function imageExists(image_url) {
    let http = new XMLHttpRequest();
    http.open("HEAD", image_url, false);
    http.send();
    return http.status !== 404;
  }

  return (
    <React.Fragment>
      {image && imageExists(image) ? (
        <img
          src={image}
          alt={children}
          className="avatar img-fluid rounded-circle"
        />
      ) : (
        <div className="avatar img-fluid rounded-circle">{texto}</div>
      )}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/componentes/avatar/index.js